import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ProjectService} from '../project.service';
import {FormBuilder, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {Sms} from '../../model/sms/sms';
import {ThirdPartyShare} from '../../model/social-sharing/thirdPartyShare';
import {TextMessage} from '../../model/email/TextMessage';
import {EmailImage} from '../../model/email/emailImage';

import {Project} from '../../model/project';
import {Questionnaire} from '../../model/questionnaire';
import {Terminal} from '../../model/terminal';
import {MaterialChipsInputComponent} from '../tags/materialChipsInput.component';
import {TSMap} from 'typescript-map';
import {ValidationService} from '../../service/validation-service';
import {Json2TypescriptUtil} from '../../util/json2TypescriptUtil';
import {MultipleCondition} from '../../model/Conditions/MultipleCondition';
import {QuestionCondition} from '../../model/Conditions/QuestionCondition';
import {BooleanOperator} from '../../model/Conditions/BooleanOperator';


@Component({

  selector: 'create-sms-dialog',
  styles: [
      `
      ::-webkit-scrollbar {
        width: 14px;
        height: 5px;
        background-color: #F5F3F0;
      }
      ::-webkit-scrollbar-thumb {
        height: 6px;
        border: 4px solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
        -webkit-border-radius: 7px;
        background-color:#BACEFF;
        -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
      }
      ::-webkit-scrollbar-button {
        width: 14px;
        height: 14px;
        display: none;
      }
      ::-webkit-scrollbar-corner {
        background-color: transparent;
      }



      .smsWindow{margin-top:-4px;height:40px;}
      .modal-title{padding-left:3%;}
      .modal-dialog {
        width: 50%;
        margin: auto;
      }
      .modal-body{padding-left:50px; padding-right:50px; overflow-y:scroll; height:600px;}
      .modal-footer{
        border-top:groove;
        background-color:#ECE8E5;
      }
      .ContentSection {
        padding-left: 20px;
      }

      .sectionTitle {
        font-size: large;
        font-weight: bold;
      }

      .mainTable {
        margin-left: 20px;
      }

      .borderGray {
        border: 1px solid #ccc;
      }

      .collapse,.innerCollapse {
        border: 1px dashed #1c71ff;
        margin-top:5px;
      }
      .innerCollapse{margin-left: 5px;margin-right:5px;margin-bottom: 5px;}

      #btnRemoveAccordion {
        float: right;
      }

      .borderRed {
        border: 1px solid red;
      }

      .mainTable {
        width: 100%;
      }

      .twitterTable {
        margin-left: 20px;
      }

      .downloadSection {
        margin-left: 20px;
      }

      .facebookTable {
        margin-left: 20px;
      }

      .btn.btn-success {
        color: #ffffff;
        background-color: #5CB85C;
        background-image: linear-gradient(to bottom, #5CB85C, #419641);
        border-color: #3E8F3E #3E8F3E #3E8F3E;
      }

      .btn.btn-success:hover {
        color: #ffffff;
        background-color: #419641;
        background-image: linear-gradient(to bottom, #419641, #419641);
        border-color: #3E8F3E #3E8F3E #3E8F3E;
      }
      form{ width:100%;}

      .modal-dialog {
        max-width: 1900px;
        margin: 50px auto auto;
        background-color: #0064FE;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
      }

      .modal-header {
        height:56px;
        background-image: url("../../../assets/images/headerBack.jpg");
        color: antiquewhite;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
      }
      .modal-content{
        border-top-right-radius: 18px;
        border-top-left-radius: 18px;
        background-color: #0064FE;
        padding-bottom: 3px;
        padding-left: 3px;
        padding-right: 3px;
      }

      .modalBodyContainer{
        background-color:  #ECE8E5;
      }
      .closeIcon:hover{ width: 32px;background-image: url("../../../assets/images/closeBtnHovered.png");}

      .closeIcon{ width: 32px;background-image: url("../../../assets/images/closeBtn.png");}

      .btn-outline-danger {
        background-color: #d6462e;
        border-style: solid;
        border-color: white;
        border-width: 2px;
        padding: 0;
      }
      .closeX{color:azure;size:25px;}
      .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
      .btn-danger:hover{background-color: #FF2400;}
      .alert{font-weight: bold;color: red;font-size: 15px;margin-left:-20px;}
      .exclamation{margin-right:5px;}
    `
  ],
  template: `
    <div class="modal" tabindex="-1" role="dialog" [style.display]="!hide ? 'inline' : 'none'" style="margin : 20px;">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <!-- header-->
          <div class="modal-header">
            <h4><img alt="icon" class="smsWindow" src="../../assets/images/iPhoneSms.png"></h4>
            <h4 class="modal-title">Content Definition</h4>
            <h4 class="closeBtnH4"><button (click)="hideDialog();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
              <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../../assets/images/closeBtn.png"></span>
            </button></h4>
          </div>
          <div class="modalBodyContainer">
          <div class="modal-body">
            <!-- Texts -->
            <div class="row" style="margin-top:20px;">
              <form [formGroup]=this.smsForm>
                <div class="form-group">
                  <div class="card col-md-12">
                    <div class="card-body">
                      <div class="sectionTitle">Language</div>
                        <div class="ContentSection">
                          <div class="mat-app-background basic-container">
                            <material-chips-input (reload)="loadSmsFormFromSmsModel($event)">loading</material-chips-input>
                            <p *ngIf="this.smsLanguage==null || this.smsLanguage.length===0" class="alert"><span class="exclamation"><i class="fas fa-exclamation-circle"></i></span>Define and select a language before creating your sms content.</p>
                          </div>
                        </div>
                        <div class="sectionTitle">Mobile Question Number</div>
                        <input type="text" formControlName="number" class="form-control" name="number">

                        <div class="sectionTitle">Title</div>
                        <input type="text" formControlName="title" class="form-control" name="title">
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="row">
                <div class="card col-md-12">
                  <div class="card-body">
                    <div class="sectionTitle">SMS-Media-Content</div>
                      <button class="btn btn-info" type="button" data-toggle="collapse" data-target="#smsMedia" aria-expanded="false" aria-controls="smsMedia">
                        Manage Media Content
                      </button>
                    <div class="collapse" id="smsMedia">
                <div class="card card-body">
                  <div class="panel-group" id="accordion">
                    <div class="panel panel-default">
                      <div class="panel-heading">
                        <a class="btn btn-primary btn-sm" data-toggle="collapse" data-parent="#accordion" href="#media">
                          <h6>
                            Media Content
                          </h6>
                        </a>
                      </div>
                      <div id="media" class="innerCollapse collapse">
                        <div class="card card-body">
                          <form [formGroup]=this.smsForm>
                            <div class="form-group" formGroupName="smsMedia">
                              <label>Question Number</label>
                              <input type="text" formControlName="questionNo"  class="form-control"/>
                              <!--<control-message [control]="this.smsForm['controls'].smsMedia['controls'].questionNo"></control-message>-->
                            </div>
                            <div class="form-group" formGroupName="smsMedia">
                              <label>Choice Number</label>
                              <input type="text" formControlName="choiceNo" class="form-control"/>
                              <!--<control-message [control]="this.smsForm['controls'].smsMedia['controls'].choiceNo"></control-message>-->
                            </div>
                            <div class="form-group" formGroupName="smsMedia">
                              <label>Identification attribute</label>
                              <input type="text" formControlName="uid" class="form-control"/>
                              <!--<control-message [control]="this.smsForm['controls'].smsMedia['controls'].identity"></control-message>-->
                            </div>
                            <div class="form-group" formGroupName="smsMedia">
                              <label>Link To Url</label>
                              <input type="checkbox" formControlName="linkToUrl"/>
                            </div>
                            <div *ngIf="this.smsForm['controls'].smsMedia['controls'].linkToUrl.value" formGroupName="smsMedia">
                              <label>Destination Url</label>
                              <input type="text" formControlName="shareLink" placeholder="eg:url to microsite"/>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                  </div>
                </div>
            </div>
            <div class="row ">
                <div class="card col-md-12">
                  <div class="card-body">
              <div class="sectionTitle">Message</div>
                <button data-toggle="collapse" href="#smsMessageContent" role="button" aria-expanded="false"
                        aria-controls="smsMediaContent" type="button" class="btn btn-info ">Manage Message Content
                </button>
              <div class="collapse" id="smsMessageContent">
                <div class="panel-group" id="accordion">
                  <div  class="card mb-0">
                    <div class="card-header collapsed">
                      <a class="btn btn-primary btn-sm" data-toggle="collapse" data-parent="#accordion" href="#sms">
                        <h6>
                          Message Content
                        </h6>
                      </a>
                    </div>
                    <div id="sms" class="innerCollapse collapse">
                      <div class="card card-body">
                        <form [formGroup]=this.smsForm>
                          <div class="form-group" formGroupName="texto">
                            <label>Message</label>
                            <textarea formControlName="message" rows="10" cols="50" style="width:100%"></textarea>
                            <!--<control-message [control]="this.smsForm['controls'].texto['controls'].message"></control-message>-->
                          </div>
                          <div class="form-group" formGroupName="texto">
                            <label>Identifier</label>
                            <input type="text" formControlName="uid" class="form-control"/>
                            <!--<control-message [control]="this.smsForm['controls'].texto['controls'].uid"></control-message>-->
                          </div>
                          <div class="form-group" formGroupName="texto">
                            <label>Clear Text</label>
                            <input type="checkbox" formControlName="clearText"/>
                          </div>
                          <div formGroupName="texto">
                            <table formGroupName="textLinks">
                              <thead>
                              <tr>
                                <td>Word</td>
                                <td>Link</td>
                                <td>Description</td>
                                <td>Action</td>
                              </tr>
                              <tr *ngFor="let item of this.getLinks(this.smsLanguage)">
                                <td>{{item.link.texts[this.smsLanguage]}}</td>
                                <td>{{item.link.links[this.smsLanguage]}}</td>
                                <td>{{item.link.descriptions[this.smsLanguage]}}</td>
                                <td>
                                  <button type="button" class="btn btn-danger " (click)="removeWord(item.link.texts[this.smsLanguage])">
                                    <span><i class="fas fa-times"></i></span></button>
                                </td>
                              </tr>
                              <tr>
                                <td><input formControlName="word" class="form-control"></td>
                                <td><input formControlName="hyperLink" class="form-control"></td>
                                <td><input formControlName="description" class="form-control"></td>
                                <td>
                                  <button type="button" class="btn btn-success " (click)="onAddMessageLink()">Add</button>
                                </td>
                              </tr>
                              </thead>
                            </table>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                  </div>
                </div>
              </div>
            <div class="row">
                <div class="card col-md-12">
                  <div class="card-body">
              <div class="sectionTitle">SMS Conditions</div>
              <button data-toggle="collapse" href="#smsConditions" role="button" aria-expanded="false"
                      aria-controls="smsConditions" type="button" class="btn btn-info ">Manage Conditions
              </button>
              <div class="collapse" id="smsConditions">
                <button type="button" class="btn btn-success btn-sm" (click)="onSmsAddConditionsContent()"><span><i class="fas fa-plus"></i></span></button>
                <ng-container *ngIf="this.smsConditions.length>0">
                  <br/>
                  <br/>
                  <label>SMS Conditions Logical Operator</label>
                  <ngx-select
                      [allowClear]="false"
                      [placeholder] =  this.extractBooleanOperatorValue()
                      [items]="this.conditionOperators"
                      (select)="conditionLogicalOperatorSelected($event)">
                  </ngx-select>
                  <br/>
                  <br/>
                </ng-container>
                <div class="panel-group" id="accordion">
                  <div class="card mb-0" *ngFor="let condKey of this.smsConditions.keys()">
                    <div class="card-header">
                      <a class="btn btn-primary btn-sm" data-toggle="collapse" data-parent="#accordion" href="#{{condKey}}">
                        <h6>
                          Condition
                        </h6>
                      </a>
                      <button id="btnRemoveAccordion" (click)="onSmsRemoveConditionContent(condKey)" type="button"
                              class="btn btn-outline-danger btn-sm">Remove
                      </button>
                    </div>
                    <div id="{{condKey}}" class="innerCollapse collapse">
                      <div class="card card--body">
                        <form [formGroup]=this.getConditionFormRef(condKey)>
                          <div class="form-group">
                            <label>Question Number</label>
                            <input type="text" formControlName="questionNo"  class="form-control"/>
                            <!--<control-message [control]="this.getConditionFormRef(cond.key).controls.questionNo"></control-message>-->
                          </div>
                          <div class="form-group">
                            <label>Choice Number</label>
                            <input type="text" formControlName="choiceNo" class="form-control"/>
                            <!--<control-message [control]="this.getConditionFormRef(cond.key).controls.choiceNo"></control-message>-->
                          </div>
                          <div class="form-group">
                            <label>Question Type</label>
                            <input type="text" formControlName="questionType" class="form-control"/>
                            <!--<control-message [control]="this.getConditionFormRef(cond.key).controls.questionType"></control-message>-->
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                  </div>
                </div>
              </div>
          </div>
          <!-- footer-->
          <div class="modal-footer ">
            <button type="button" (click)="newSmsCreate()" class="btn btn-primary clickable hand" id="submit"><span
              class="glyphicon glyphicon-floppy-disk"></span> {{'save' | translate}}
            </button>
          </div>
          </div>
        </div>
      </div>
    </div>
  `
})

export class CreateSmsComponent  implements OnInit,OnChanges {

  // TODO: try to find a common interface between create-email and create-sms; There are few methods that can be factorized
  private smsForm:FormGroup;
  private smsLanguage: string;
  private sms:Sms =  new Sms();
  @Input() hide = true;
  private emailMessageLinks:TSMap<string,ThirdPartyShare> = new TSMap();
  private found = false;
  private smsConditions:TSMap<string,QuestionCondition> = new TSMap();
  private smsConditionForm:TSMap<string, FormGroup> = new TSMap();
  private _errorMessage;
  private langArr:string[];


  @Input() project:Project;
  @Input() questionnaire:Questionnaire;
  @Input() terminal:Terminal;
  @ViewChild(MaterialChipsInputComponent) materialTagChips:MaterialChipsInputComponent;

  // tslint:disable-next-line:no-input-rename
  @Output() NewSmsCreate: EventEmitter<any> = new EventEmitter();
  // tslint:disable-next-line:no-input-rename
  @Output() CancelSmsEmail: EventEmitter<any> = new EventEmitter();
  submitted: ValidationErrors;
  private conditionOperators:string[] =['AND','OR','XOR'];
  private selectedConditionOperator:BooleanOperator;



  constructor(private _projectService: ProjectService, private _formBuilder:FormBuilder) {

  }
  ngOnInit():void {

      this.smsForm = this._formBuilder.group({
        uid:[],
        number:['',ValidationService.phoneValidator],
        title:[],
        smsMedia:this._formBuilder.group(
          {questionNo:['',ValidationService.questionAndChoiceValidation],
            choiceNo:['',ValidationService.questionAndChoiceValidation],
            uid:['',Validators.maxLength(12)],
            linkToUrl:[false,null],
            shareLink:[]
          }
        ),
        texto:this._formBuilder.group(
          {
            message: ['', Validators.minLength(10)],
            uid: ['', Validators.maxLength(12)],
            clearText: [false,],
            textLinks: this._formBuilder.group({
              word: [],
              hyperLink: [],
              description: []
            })
          }
        )
      });

    this.getSMS(this.getTerminalTypeID());
  }

  private getSMS(typeId:number) {
    this._projectService.getSms(this.project.id,this.questionnaire.id,this.terminal.id,typeId).subscribe((sms:string) => {
          console.log(sms);
          this.sms = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(sms,Sms);
          if(this.sms !== null) {
                this.setValidLanguages();
                this.loadSmsFormFromSmsModel(this.langArr[0]);
                this.materialTagChips.setLanguageArray(this.langArr);
                this.materialTagChips.setSelectedLanguage(this.smsLanguage);
                this.materialTagChips.setId(this.smsLanguage);

          } else {
            this.resetForms();
          }
        },
        error => this._errorMessage = <any>error);
  }

  getLinks(lg:string):ThirdPartyShare[] {

    const arr: ThirdPartyShare[] = [];
    for (const key of this.emailMessageLinks.keys()) {
      if (this.emailMessageLinks.get(key).link.links.get(lg) != null) {   // null also verifies undefined
        arr.push(this.emailMessageLinks.get(key));
      }
    }

    return arr;
  }

  public selected(value:any):void {
    this.smsLanguage = value;
  }

  onSmsAddConditionsContent() {
    let index;
    index = this.smsConditions.size();
    this.smsConditionForm.set('condition'+index,this.getConditionForm());
    this.smsConditions.set('condition'+index, new QuestionCondition());
  }
  onSmsRemoveConditionContent(key: string) {
    this.smsConditions.delete(key);
    this.smsConditionForm.delete(key);
  }


  getConditionForm() {
    return this._formBuilder.group(
      {
        questionNo: ['', Validators.pattern('\d{1,3}')],
        choiceNo: ['', Validators.pattern('\d{1,3}')],
        questionType: ['', Validators.maxLength(12)]
      }
    );
  }

  getConditionFormRef(key:string) {
    return this.smsConditionForm.get(key);
  }

  onAddMessageLink() {
    let thirdParty;
    if(this.emailMessageLinks.has(this.smsForm['controls'].texto['controls'].textLinks['controls'].word.value)) {
      thirdParty = this.emailMessageLinks.get(this.smsForm['controls'].texto['controls'].textLinks['controls'].word.value);
    } else {
      thirdParty = new ThirdPartyShare();
    }

    thirdParty.link.links.set(this.smsLanguage,this.smsForm['controls'].texto['controls'].textLinks['controls'].hyperLink.value);
    thirdParty.link.texts.set(this.smsLanguage,this.smsForm['controls'].texto['controls'].textLinks['controls'].word.value);
    thirdParty.link.descriptions.set(this.smsLanguage,this.smsForm['controls'].texto['controls'].textLinks['controls'].description.value);
    thirdParty.link.uid = 'messageLinks';

    this.emailMessageLinks.set(this.smsForm['controls'].texto['controls'].textLinks['controls'].word.value,thirdParty);


  }

  removeWord(key: any) {
    this.emailMessageLinks.delete(key);
  }

  hideDialog() {
    this.sms = new Sms();
    this.CancelSmsEmail.emit();
  }

  newSmsCreate() {
    console.log(this.smsForm);
    this.saveAndCreate();
    const smsJson = JSON.stringify(this.sms);

    console.log(smsJson);

    this.NewSmsCreate.emit(this.sms);

  }

  private resetForms() {

    this.smsForm.reset();
    if(this.langArr!=null) {
      this.langArr.length =0;
    }
    this.materialTagChips.setLanguageArray(this.langArr);
    this.smsLanguage = '';

    for(const key of this.smsConditions.keys()) {
      this.smsConditionForm.get(String(key)).reset();
    }
    this.smsConditions.clear();
    this.sms = new Sms();
    this.emailMessageLinks.clear();
  }

  saveAndCreate() {

      if(this.sms === null) {
        this.sms = new Sms();
      }

      this.sms.uid = 'smsDefinition';
      this.sms.phoneNumber.questionNo = this.smsForm['controls'].number.value;
      this.sms.titleMap.set(this.smsLanguage,this.smsForm['controls'].title.value);


    const conditionsEvaluator = new MultipleCondition();
    conditionsEvaluator.setConditionClass('multiple');
    for(const key of this.smsConditions.keys()) {
      const questionCondition = new QuestionCondition();
      questionCondition.setQuestionNo(this.smsConditionForm.get(key)['controls'].questionNo.value);
      questionCondition.setChoiceNo(this.smsConditionForm.get(key)['controls'].choiceNo.value);
      questionCondition.type = this.smsConditionForm.get(key)['controls'].questionType.value;
      questionCondition.conditionClass = 'simple';
      conditionsEvaluator.addCondition(questionCondition);
    }
    conditionsEvaluator.setBooleanOperator(this.selectedConditionOperator);
    this.sms.condition = conditionsEvaluator;


      let smsText;
      if(this.sms.messageArray.find(m => m.uid === this.smsForm['controls'].texto['controls'].uid.value)) {
        smsText = this.sms.messageArray.find(m => m.uid === this.smsForm['controls'].texto['controls'].uid.value);
        this.found = true;
      } else {
        smsText = new TextMessage();
      }

      smsText.texts.set(this.smsLanguage,this.smsForm['controls'].texto['controls'].message.value);
      smsText.clearText = this.smsForm['controls'].texto['controls'].clearText.value;
      smsText.uid = this.smsForm['controls'].texto['controls'].uid.value;

      if(!this.found) {
        this.sms.messageArray.push(smsText);
      }

      this.found = false;

      let emailImage;
      if(this.sms.mediaContent[0]!=null) {// this.sms.mediaContent.find(m => m.questionNo === this.smsForm['controls'].smsMedia['controls'].questionNo.value)) {
        emailImage = this.sms.mediaContent[0];  // this.sms.mediaContent.find(m => m.questionNo === this.smsForm['controls'].smsMedia['controls'].questionNo.value);
        this.found = true;
      } else {
        emailImage = new EmailImage();
      }

      const qNo = this.smsForm['controls'].smsMedia['controls'].questionNo.value;
      const cNo = this.smsForm['controls'].smsMedia['controls'].choiceNo.value;
      emailImage.questionNo = qNo===''?0:qNo;
      emailImage.choiceNo = cNo===''?0:cNo;
      emailImage.linkToUrl = this.smsForm['controls'].smsMedia['controls'].linkToUrl.value;
      emailImage.uid = this.smsForm['controls'].smsMedia['controls'].uid.value;
      if(emailImage.linkToUrl === false) {
        emailImage.externalLink.links.set(this.smsLanguage, null);
      } else {
        emailImage.externalLink.links.set(this.smsLanguage, this.smsForm['controls'].smsMedia['controls'].shareLink.value);
      }
      if(!this.found && emailImage.questionNo!=='') {
        this.sms.mediaContent.push(emailImage);
      }

      const tmp:TSMap<string,ThirdPartyShare> = new TSMap();

    const thirdParty = new ThirdPartyShare();
    thirdParty.link.links.set('fr','www.google.ca');
    thirdParty.link.texts.set('fr','Avion');
    thirdParty.link.descriptions.set('fr','Avion de chasse');
    thirdParty.link.uid = 'messageLinks';

      tmp.set('a',thirdParty);
      if(tmp.has('a')) {
        console.log('bingo');
      }
      console.log(tmp.toJSON());

      this.found = false;
      /*for(const [key, value] of Object.entries(this.sms.linksMap)) {
        if(this.emailMessageLinks.has(key))
      }*/
      for(const key of this.emailMessageLinks.keys()) {
        if(Object.keys(this.sms.linksMap).findIndex(cle => cle.valueOf()===key) === -1) {
          this.sms.linksMap.set(key,this.emailMessageLinks.get(key));
        } else {
          this.sms.linksMap.get(key).link.links.set(this.smsLanguage,this.emailMessageLinks.get(key).link.links.get(this.smsLanguage));
          this.sms.linksMap.get(key).link.descriptions.set(this.smsLanguage,this.emailMessageLinks.get(key).link.descriptions.get(this.smsLanguage));
          this.sms.linksMap.get(key).link.texts.set(this.smsLanguage,this.emailMessageLinks.get(key).link.texts.get(this.smsLanguage));
        }
      }

  }

  private setValidLanguages() {
      this.langArr = this.sms.titleMap.keys();
  }

  loadSmsFormFromSmsModel(lg:string) {
    this.smsLanguage = lg;

    // this.langArr =  Object.keys(this.sms.titleMap);

    // this.smsForm['controls'].language.setValue(lg);
    this.smsForm['controls'].number.setValue(this.sms.phoneNumber.questionNo);
    this.smsForm['controls'].title.setValue(this.sms.titleMap.get(lg));

    let x =0;
    for(const msg of this.sms.messageArray) {
      this.smsForm['controls'].texto['controls'].message.setValue(msg.texts.get(lg));
      this.smsForm['controls'].texto['controls'].uid.setValue(msg.uid);
      this.smsForm['controls'].texto['controls'].clearText[0] = msg.clearText;
      x++;
    }

    x=0;
    let thirdParty: ThirdPartyShare;
    for(const key of this.sms.linksMap.keys()) {
      if(this.sms.linksMap.get(key)!=null) {
        thirdParty = this.sms.linksMap.get(key);
      } else {
        thirdParty = new ThirdPartyShare();
      }
      console.log(key);
      if(this.sms.linksMap.get(key).link != null) {
        thirdParty.link.links.set(lg,this.sms.linksMap.get(key).link.links.get(lg));
        thirdParty.link.texts.set(lg,this.sms.linksMap.get(key).link.texts.get(lg));
        thirdParty.link.descriptions.set(lg,this.sms.linksMap.get(key).link.descriptions.get(lg));
        thirdParty.link.uid = 'messageLinks';

        this.emailMessageLinks.set(key, thirdParty);
        x++;
      }
    }
    // this.sms.linksMap = this.emailMessageLinks; // unnecessary


    x = 0;
    if(this.sms.condition.conditionClass === 'multiple') {
      const condMultiple = this.sms.condition as MultipleCondition;
      const conditionsArr = condMultiple.getConditions();
      for (const cond of conditionsArr) {

        if(cond.conditionClass === 'simple') {
          const condi = cond as QuestionCondition;
          this.smsConditions.set('condition' + x, condi);
          this.smsConditionForm.set('condition' + x, this.getConditionForm());
          this.smsConditionForm.get('condition' + x)['controls'].questionNo.setValue(condi.getQuestionNo());
          this.smsConditionForm.get('condition' + x)['controls'].choiceNo.setValue(condi.getChoiceNo());
          this.smsConditionForm.get('condition' + x)['controls'].questionType.setValue(condi.type);
        }

        x++;
      }
    }
    x = 0;
    for(const img of this.sms.mediaContent) {
      this.smsForm['controls'].smsMedia['controls'].questionNo.setValue(img.questionNo);
      this.smsForm['controls'].smsMedia['controls'].choiceNo.setValue(img.choiceNo);
      this.smsForm['controls'].smsMedia['controls'].linkToUrl.setValue(img.linkToUrl);
      this.smsForm['controls'].smsMedia['controls'].uid.setValue(img.uid);
      this.smsForm['controls'].smsMedia['controls'].shareLink.setValue(img.externalLink.links.get(lg));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
      this.getSMS(this.getTerminalTypeID());
  }

  private getTerminalTypeID():number {
    return this.terminal.type === 'Android'? 2 :1;
  }

  // TODO: In a futur refact think as creating a common abstract class for email and sms create
  private conditionLogicalOperatorSelected(value: string) {
    switch(value) {
      case 'AND':this.selectedConditionOperator = BooleanOperator.AND;break;
      case 'OR':this.selectedConditionOperator = BooleanOperator.OR;break;
      case 'XOR':this.selectedConditionOperator = BooleanOperator.XOR;break;
      default: this.selectedConditionOperator = BooleanOperator.AND;break;
    }
  }

  private extractBooleanOperatorValue():string {
    return BooleanOperator[this.selectedConditionOperator];
  }
}
